import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import exportToExcel from "../Report/ExportExcel";

const tripTableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  marginBottom: "20px",
};

const thTdStyle = {
  padding: "8px",
  border: "1px solid #ddd",
  textAlign: "left",
};

const thStyle = {
  backgroundColor: "#f2f2f2",
};

const PassengerTrips = ({ name, prRef, trips }) => {
  const columns = [
    "Pickup Location",
    "Destination",
    "Pickup Time",
    "Drop-off Time",
    "Estimated Price",
    "Actual Price",
    "Payment Method",
    "Status",
    "Driver Name",
    "Driver Phone",
  ];

  return (
    <div ref={prRef}>
      <Header
        title={"Passenger Trips"}
        subTitle={"Trips of " + name + " for"}
      />
      <table style={tripTableStyle}>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column} style={{ ...thTdStyle, ...thStyle }}>
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {trips.map((trip, index) => (
            <tr key={index}>
              <td style={thTdStyle}>{trip.pickUpPlace}</td>
              <td style={thTdStyle}>{trip.destinationPlace}</td>
              <td style={thTdStyle}>
                {new Date(trip.pickUpTime).toLocaleString()}
              </td>
              <td style={thTdStyle}>
                {new Date(trip.dropOffTime).toLocaleString()}
              </td>
              <td style={thTdStyle}>{trip.estimatedPrice}</td>
              <td style={thTdStyle}>{trip.actualPrice}</td>
              <td style={thTdStyle}>{trip.paymentMethod}</td>
              <td style={thTdStyle}>{trip.status}</td>
              <td
                style={thTdStyle}
              >{`${trip.driver.firstName} ${trip.driver.lastName}`}</td>
              <td style={thTdStyle}>{trip.driver.phoneNumber}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <Footer />
    </div>
  );
};

export const exportExcelPassengerTrips = (name, trips) => {
  const formattedTrips = trips.map((trip) => ({
    "Pickup Location": trip.pickUpPlace,
    Destination: trip.destinationPlace,
    "Pickup Time": new Date(trip.pickUpTime).toLocaleString(),
    "Drop-off Time": new Date(trip.dropOffTime).toLocaleString(),
    "Estimated Price": trip.estimatedPrice,
    "Actual Price": trip.actualPrice,
    "Payment Method": trip.paymentMethod,
    Status: trip.status,
    "Driver Name": `${trip.driver.firstName} ${trip.driver.lastName}`,
    "Driver Phone": trip.driver.phoneNumber,
  }));

  exportToExcel(formattedTrips, `PassengerTrips_${name}`, [
    "Pickup Location",
    "Destination",
    "Pickup Time",
    "Drop-off Time",
    "Estimated Price",
    "Actual Price",
    "Payment Method",
    "Status",
    "Driver Name",
    "Driver Phone",
  ]);
};

export default PassengerTrips;
